/* eslint-disable @typescript-eslint/no-explicit-any */

import {useQuery} from '@vue/apollo-composable';
import gql from 'graphql-tag';
import type {Ref} from 'vue';
import {computed, toRef} from 'vue';
import type {Setting} from '../index';
import {useSofieConfig} from './config';

export function useSofieSettings() {
  const config = useSofieConfig();

  const query = useQuery<{ settings: Setting[] }>(
    gql(config.queries.settings),
  );

  return {
    ...query,
    settings: computed<Record<string, any>>(() => Object.fromEntries(
      query.result.value?.settings?.map(setting => [setting.key, setting.value]) ?? [],
    )),
  };
}

export function useSofieSetting<T = any>(key: string | Ref<string>) {
  const keyRef = toRef(key);
  const query = useSofieSettings();

  return {
    ...query,
    value: computed<T | null | undefined>(() => query.settings.value[keyRef.value]),
  };
}
